import {
  Smartphone,
  Monitor,
  Cpu,
  Camera,
  Gamepad2,
  AppWindow,
  Download,
  Shirt,
  Baby,
  Footprints,
  Watch,
  Briefcase,
  Sofa,
  UtensilsCrossed,
  Refrigerator,
  TreePine,
  Wrench,
  Sparkles,
  Heart,
  Dumbbell,
  Car,
  ToyBrick,
  PawPrint,
  ShoppingBasket,
  Leaf,
  BookOpen,
  Film,
  Music,
  Trophy,
  Palette,
  Scissors,
  Building2,
  Factory,
  Tractor,
  Gift,
  HandHelping,
  MoreHorizontal,
  type LucideIcon,
} from 'lucide-react';

// Category name to icon mapping for product forms
export const CATEGORY_ICONS: Record<string, LucideIcon> = {
  phones_tablets: Smartphone,
  computers: Monitor,
  electronics: Cpu,
  cameras_photo: Camera,
  gaming: Gamepad2,
  software: AppWindow,
  apps_digital: Download,
  clothing_men: Shirt,
  clothing_women: Shirt,
  clothing_kids: Baby,
  shoes: Footprints,
  jewelry_watches: Watch,
  luggage_travel: Briefcase,
  furniture_decor: Sofa,
  kitchen_dining: UtensilsCrossed,
  home_appliances: Refrigerator,
  garden_outdoor: TreePine,
  tools_improvement: Wrench,
  beauty_cosmetics: Sparkles,
  health_wellness: Heart,
  sports_fitness: Dumbbell,
  baby_products: Baby,
  toys_games: ToyBrick,
  pets: PawPrint,
  groceries: ShoppingBasket,
  local_products: Leaf,
  books: BookOpen,
  movies_music: Film,
  musical_instruments: Music,
  collectibles: Trophy,
  handmade: Palette,
  crafts_supplies: Scissors,
  office_products: Building2,
  industrial: Factory,
  automotive: Car,
  agriculture: Tractor,
  gift_cards: Gift,
  services: HandHelping,
  other: MoreHorizontal,
};

// Get icon for category name with fallback
export const getCategoryIcon = (categoryName: string): LucideIcon => {
  return CATEGORY_ICONS[categoryName] || MoreHorizontal;
};

// Re-export MoreHorizontal as default fallback icon
export { MoreHorizontal as DefaultCategoryIcon };
